const warningDueStatement = {
  'warningDueStatement.label': 'Valor total',
  'warningDueStatement.dueDays': 'Dias em atraso',
};

export default warningDueStatement;
